function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416.779,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 33.122,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.527,
    y: 401.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 8.693,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.586,
    y: 389.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.192,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 43.193,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.556,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 6.333,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.471,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 93.676,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M237.014,337.8H43.915c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708 h193.099c3.146,0,5.707,2.561,5.707,5.708v271.432C242.721,335.239,240.16,337.8,237.014,337.8z M43.915,55.203 c-3.01,0-5.458,2.448-5.458,5.458v271.432c0,3.01,2.448,5.458,5.458,5.458h193.099c3.009,0,5.457-2.448,5.457-5.458V60.66 c0-3.009-2.448-5.458-5.457-5.458H43.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M453.31,337.8H260.212c-3.147,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.561-5.708,5.707-5.708 H453.31c3.148,0,5.708,2.561,5.708,5.708v271.432C459.019,335.239,456.458,337.8,453.31,337.8z M260.212,55.203 c-3.009,0-5.457,2.448-5.457,5.458v271.432c0,3.01,2.448,5.458,5.457,5.458H453.31c3.01,0,5.458-2.448,5.458-5.458V60.66 c0-3.009-2.448-5.458-5.458-5.458H260.212z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    style: {
      fill: "#EBEBEB"
    },
    width: 500,
    height: 0.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M83.117,328.246c0,0-4.653-52.29-28.946-102.507c0,0,35.863,33.475,37.12,102.507H83.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M112.445,332.333c0,0,4.653-52.29,28.946-102.507c0,0-35.863,33.475-37.12,102.507H112.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M88.776,336.342c0,0-19.514-91.033-16.045-139.237c0,0,26.106,53.662,24.848,134.778 L88.776,336.342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M103.192,330.595c0,0,1.86-59.429,11.401-88.781c0,0,7.957,37.271-5.26,87.366L103.192,330.595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M97.579,331.883c0,0-6.288-79.248,11.318-114.766c0,0,1.886,72.007-2.515,114.766H97.579z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "117.682,382.564 77.881,382.564 72.188,323.833 123.374,323.833  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "239.006,382.564 235.006,382.564 234.006,274.49 240.006,274.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "398.124,382.564 394.124,382.564 393.124,274.49 399.124,274.49  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M411.263,277.039H221.867c-2.815,0-5.096-2.282-5.096-5.096l0,0h199.588l0,0 C416.359,274.757,414.077,277.039,411.263,277.039z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "333.517,366.087 333.517,315.829 323.135,315.829 323.135,366.087 292.291,368.655  292.291,373.655 328.326,371.655 364.361,373.655 364.361,368.655  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M296.414,378.442c0,2.277-1.846,4.122-4.122,4.122c-2.277,0-4.122-1.846-4.122-4.122 c0-2.277,1.846-4.122,4.122-4.122C294.568,374.319,296.414,376.165,296.414,378.442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M368.484,378.442c0,2.277-1.846,4.122-4.122,4.122c-2.277,0-4.122-1.846-4.122-4.122 c0-2.277,1.846-4.122,4.122-4.122C366.638,374.319,368.484,376.165,368.484,378.442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M332.449,378.442c0,2.277-1.846,4.122-4.122,4.122s-4.122-1.846-4.122-4.122 c0-2.277,1.846-4.122,4.122-4.122S332.449,376.165,332.449,378.442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M299.37,311.701l-1.844-59.916c-0.087-2.828-2.405-5.076-5.235-5.076l0,0v66.832 c0,2.893,2.345,5.238,5.238,5.238h66.832l0,0c0-2.83-2.248-5.147-5.076-5.234L299.37,311.701z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M344.145,257.01c-0.026-1.536-1.279-2.773-2.815-2.773h-16.792c-1.537,0-2.79,1.237-2.815,2.773 c-0.001,0.071-0.002,0.137-0.003,0.207c-0.616-0.197-1.25-0.309-1.87-0.309c-2.754,0-4.604,2.15-4.604,5.351 c0,3.062,3.219,5.351,6.097,5.351c0.303,0,0.589-0.036,0.868-0.087c0.677,2.079,1.915,3.904,3.544,5.288h14.359 c2.519-2.139,4.123-5.321,4.123-8.886C344.235,262.815,344.198,260.211,344.145,257.01z M321.341,265.816 c-1.95,0-4.304-1.587-4.304-3.558c0-0.834,0.203-3.558,2.811-3.558c0.602,0,1.241,0.152,1.839,0.419 c-0.034,2.211-0.056,3.952-0.056,4.805c0,0.636,0.068,1.254,0.166,1.862C321.654,265.806,321.503,265.816,321.341,265.816z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M93.889,172.943l16.082-46.244c7.612-21.89,31.635-33.348,53.437-25.487l57.568,20.756 c15.853,5.716,33.588,1.31,44.923-11.161l16.379-18.02c16.184-17.805,44.048-18.222,60.757-0.909l45.889,47.547 c20.157,20.886,13.289,55.471-13.32,67.069l0,0c-22.315,9.726-31.559,36.441-20.029,57.879l10.306,19.16 c11.704,21.761,1.987,48.868-20.876,58.237l-66.915,27.422c-22.87,9.372-48.822-3.13-55.746-26.857l-22.295-76.398 c-4.279-14.662-16.243-25.803-31.171-29.028l-44.46-9.604C99.983,222.027,85.678,196.554,93.889,172.943z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M93.889,172.943l16.082-46.244c7.612-21.89,31.635-33.348,53.437-25.487l57.568,20.756 c15.853,5.716,33.588,1.31,44.923-11.161l16.379-18.02c16.184-17.805,44.048-18.222,60.757-0.909l45.889,47.547 c20.157,20.886,13.289,55.471-13.32,67.069l0,0c-22.315,9.726-31.559,36.441-20.029,57.879l10.306,19.16 c11.704,21.761,1.987,48.868-20.876,58.237l-66.915,27.422c-22.87,9.372-48.822-3.13-55.746-26.857l-22.295-76.398 c-4.279-14.662-16.243-25.803-31.171-29.028l-44.46-9.604C99.983,222.027,85.678,196.554,93.889,172.943z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__1_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 245.178,
    cy: 412.391,
    rx: 193.889,
    ry: 11.323
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M259.834,349.896c-6.111,0-12.255-0.411-18.262-1.223l0.101-0.744 c15.596,2.108,31.835,1.453,47.186-1.924l0.161,0.732C279.496,348.833,269.677,349.896,259.834,349.896z M229.832,346.556 c-4.514-1.022-9.021-2.293-13.398-3.775l0.24-0.711c4.352,1.475,8.834,2.738,13.323,3.754L229.832,346.556z M300.545,343.658 l-0.226-0.715c7.522-2.372,14.885-5.437,21.885-9.108l0.349,0.664C315.514,338.191,308.109,341.273,300.545,343.658z  M205.312,338.451c-7.261-3.203-14.285-7.078-20.878-11.517l0.419-0.623c6.556,4.415,13.541,8.269,20.761,11.454L205.312,338.451 z M332.861,328.496l-0.405-0.631c3.864-2.484,7.646-5.2,11.241-8.073l0.468,0.586 C340.55,323.267,336.747,325.998,332.861,328.496z M174.838,319.844c-12.452-10.078-22.925-22.146-31.128-35.867l0.644-0.385 c8.158,13.646,18.573,25.647,30.956,35.669L174.838,319.844z M353.15,312.528l-0.517-0.543 c11.537-11.007,20.939-23.817,27.946-38.076l0.673,0.33C374.206,288.578,364.751,301.46,353.15,312.528z M138.047,273.479 c-2.015-4.165-3.833-8.48-5.403-12.825l0.705-0.256c1.562,4.322,3.37,8.613,5.372,12.755L138.047,273.479z M386.034,263.306 l-0.7-0.27c2.839-7.365,5.035-15.032,6.528-22.788l0.736,0.143C391.097,248.189,388.889,255.898,386.034,263.306z  M129.092,249.265c-2.019-7.657-3.37-15.562-4.013-23.495l0.747-0.061c0.64,7.888,1.983,15.749,3.992,23.364L129.092,249.265z  M394.333,228.588l-0.746-0.076c0.465-4.561,0.701-9.21,0.701-13.82v-0.28h0.75v0.28 C395.038,219.327,394.801,224.002,394.333,228.588z M125.383,213.854l-0.75-0.005c0.098-16.077,2.991-31.793,8.599-46.715 l0.702,0.264C128.358,182.236,125.481,197.866,125.383,213.854z M393.748,202.56c-1.42-15.875-5.602-31.202-12.43-45.555 l0.678-0.322c6.866,14.434,11.071,29.847,12.499,45.811L393.748,202.56z M138.599,156.485l-0.676-0.325 c2.003-4.165,4.249-8.274,6.673-12.215l0.639,0.393C142.824,148.256,140.591,152.343,138.599,156.485z M375.754,146.53 c-4.004-6.795-8.642-13.283-13.784-19.284l0.569-0.488c5.171,6.034,9.835,12.558,13.861,19.391L375.754,146.53z M151.893,134.513 l-0.602-0.447c4.737-6.367,10.07-12.357,15.853-17.805l0.515,0.546C161.908,122.225,156.603,128.182,151.893,134.513z  M353.861,118.584c-3.289-3.217-6.779-6.299-10.376-9.161l0.467-0.587c3.616,2.878,7.126,5.977,10.433,9.212L353.861,118.584z  M176.644,109.058l-0.465-0.589c12.597-9.934,26.686-17.471,41.875-22.401l0.232,0.713 C203.181,91.684,189.171,99.179,176.644,109.058z M333.884,102.449c-13.302-8.793-27.895-15.084-43.372-18.695l0.171-0.73 c15.564,3.632,30.238,9.958,43.615,18.8L333.884,102.449z M229.721,83.623l-0.167-0.731c4.499-1.029,9.111-1.836,13.708-2.398 l0.091,0.744C238.782,81.796,234.196,82.599,229.721,83.623z M278.851,81.573c-6.252-0.885-12.651-1.335-19.017-1.335 c-0.013,0-0.027,0-0.04,0c-1.534,0-3.086,0.026-4.615,0.079l-0.025-0.75c1.551-0.053,3.096-0.087,4.681-0.079 c6.401,0,12.835,0.452,19.122,1.342L278.851,81.573z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M259.834,349.896c-6.111,0-12.255-0.411-18.262-1.223l0.101-0.744 c15.596,2.108,31.835,1.453,47.186-1.924l0.161,0.732C279.496,348.833,269.677,349.896,259.834,349.896z M229.832,346.556 c-4.514-1.022-9.021-2.293-13.398-3.775l0.24-0.711c4.352,1.475,8.834,2.738,13.323,3.754L229.832,346.556z M300.545,343.658 l-0.226-0.715c7.522-2.372,14.885-5.437,21.885-9.108l0.349,0.664C315.514,338.191,308.109,341.273,300.545,343.658z  M205.312,338.451c-7.261-3.203-14.285-7.078-20.878-11.517l0.419-0.623c6.556,4.415,13.541,8.269,20.761,11.454L205.312,338.451 z M332.861,328.496l-0.405-0.631c3.864-2.484,7.646-5.2,11.241-8.073l0.468,0.586 C340.55,323.267,336.747,325.998,332.861,328.496z M174.838,319.844c-12.452-10.078-22.925-22.146-31.128-35.867l0.644-0.385 c8.158,13.646,18.573,25.647,30.956,35.669L174.838,319.844z M353.15,312.528l-0.517-0.543 c11.537-11.007,20.939-23.817,27.946-38.076l0.673,0.33C374.206,288.578,364.751,301.46,353.15,312.528z M138.047,273.479 c-2.015-4.165-3.833-8.48-5.403-12.825l0.705-0.256c1.562,4.322,3.37,8.613,5.372,12.755L138.047,273.479z M386.034,263.306 l-0.7-0.27c2.839-7.365,5.035-15.032,6.528-22.788l0.736,0.143C391.097,248.189,388.889,255.898,386.034,263.306z  M129.092,249.265c-2.019-7.657-3.37-15.562-4.013-23.495l0.747-0.061c0.64,7.888,1.983,15.749,3.992,23.364L129.092,249.265z  M394.333,228.588l-0.746-0.076c0.465-4.561,0.701-9.21,0.701-13.82v-0.28h0.75v0.28 C395.038,219.327,394.801,224.002,394.333,228.588z M125.383,213.854l-0.75-0.005c0.098-16.077,2.991-31.793,8.599-46.715 l0.702,0.264C128.358,182.236,125.481,197.866,125.383,213.854z M393.748,202.56c-1.42-15.875-5.602-31.202-12.43-45.555 l0.678-0.322c6.866,14.434,11.071,29.847,12.499,45.811L393.748,202.56z M138.599,156.485l-0.676-0.325 c2.003-4.165,4.249-8.274,6.673-12.215l0.639,0.393C142.824,148.256,140.591,152.343,138.599,156.485z M375.754,146.53 c-4.004-6.795-8.642-13.283-13.784-19.284l0.569-0.488c5.171,6.034,9.835,12.558,13.861,19.391L375.754,146.53z M151.893,134.513 l-0.602-0.447c4.737-6.367,10.07-12.357,15.853-17.805l0.515,0.546C161.908,122.225,156.603,128.182,151.893,134.513z  M353.861,118.584c-3.289-3.217-6.779-6.299-10.376-9.161l0.467-0.587c3.616,2.878,7.126,5.977,10.433,9.212L353.861,118.584z  M176.644,109.058l-0.465-0.589c12.597-9.934,26.686-17.471,41.875-22.401l0.232,0.713 C203.181,91.684,189.171,99.179,176.644,109.058z M333.884,102.449c-13.302-8.793-27.895-15.084-43.372-18.695l0.171-0.73 c15.564,3.632,30.238,9.958,43.615,18.8L333.884,102.449z M229.721,83.623l-0.167-0.731c4.499-1.029,9.111-1.836,13.708-2.398 l0.091,0.744C238.782,81.796,234.196,82.599,229.721,83.623z M278.851,81.573c-6.252-0.885-12.651-1.335-19.017-1.335 c-0.013,0-0.027,0-0.04,0c-1.534,0-3.086,0.026-4.615,0.079l-0.025-0.75c1.551-0.053,3.096-0.087,4.681-0.079 c6.401,0,12.835,0.452,19.122,1.342L278.851,81.573z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Calendar_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 98.012,
    y: 121.539,
    transform: "matrix(0.9945 -0.1045 0.1045 0.9945 -15.638 15.3875)",
    style: {
      fill: "#407BFF"
    },
    width: 81.949,
    height: 70.701
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.012,
    y: 121.539,
    transform: "matrix(0.9945 -0.1045 0.1045 0.9945 -15.638 15.3875)",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    width: 81.949,
    height: 70.701
  })), /*#__PURE__*/React.createElement("rect", {
    x: 93.625,
    y: 108.541,
    transform: "matrix(0.9945 -0.1045 0.1045 0.9945 -11.2996 14.7003)",
    style: {
      fill: "#407BFF"
    },
    width: 81.949,
    height: 13.228
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M105.137,107.21c-0.126-1.199-1.201-2.07-2.4-1.943c-1.199,0.126-2.069,1.201-1.943,2.4 c0.081,0.768,0.832,7.919,0.913,8.687c0.126,1.199,1.201,2.069,2.4,1.943c1.2-0.126,2.07-1.201,1.944-2.4 C105.985,115.282,105.201,107.825,105.137,107.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M120.823,105.561c-0.126-1.199-1.2-2.07-2.4-1.944c-1.199,0.126-2.069,1.201-1.943,2.4 c0.081,0.768,0.832,7.919,0.913,8.687c0.126,1.199,1.201,2.07,2.4,1.943c1.2-0.126,2.07-1.201,1.943-2.4 C121.672,113.633,120.888,106.176,120.823,105.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M136.51,103.912c-0.126-1.199-1.201-2.069-2.4-1.943c-1.199,0.126-2.069,1.201-1.943,2.4 c0.081,0.768,0.832,7.919,0.913,8.687c0.126,1.199,1.201,2.07,2.4,1.943c1.2-0.126,2.07-1.201,1.944-2.4 C137.358,111.985,136.574,104.527,136.51,103.912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M152.196,102.264c-0.126-1.199-1.201-2.07-2.4-1.944c-1.199,0.126-2.069,1.201-1.943,2.4 c0.081,0.768,0.832,7.919,0.913,8.687c0.126,1.199,1.201,2.069,2.4,1.943c1.2-0.126,2.07-1.201,1.944-2.4 C153.045,110.336,152.261,102.878,152.196,102.264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M167.883,100.615c-0.126-1.199-1.201-2.07-2.4-1.943c-1.199,0.126-2.069,1.201-1.943,2.4 c0.081,0.768,0.832,7.919,0.913,8.687c0.126,1.199,1.201,2.07,2.4,1.944c1.2-0.126,2.07-1.201,1.944-2.4 C168.731,108.687,167.947,101.23,167.883,100.615z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M105.137,107.21c-0.126-1.199-1.201-2.07-2.4-1.943c-1.199,0.126-2.069,1.201-1.943,2.4 c0.081,0.768,0.832,7.919,0.913,8.687c0.126,1.199,1.201,2.069,2.4,1.943c1.2-0.126,2.07-1.201,1.944-2.4 C105.985,115.282,105.201,107.825,105.137,107.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M120.823,105.561c-0.126-1.199-1.2-2.07-2.4-1.944c-1.199,0.126-2.069,1.201-1.943,2.4 c0.081,0.768,0.832,7.919,0.913,8.687c0.126,1.199,1.201,2.07,2.4,1.943c1.2-0.126,2.07-1.201,1.943-2.4 C121.672,113.633,120.888,106.176,120.823,105.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M136.51,103.912c-0.126-1.199-1.201-2.069-2.4-1.943c-1.199,0.126-2.069,1.201-1.943,2.4 c0.081,0.768,0.832,7.919,0.913,8.687c0.126,1.199,1.201,2.07,2.4,1.943c1.2-0.126,2.07-1.201,1.944-2.4 C137.358,111.985,136.574,104.527,136.51,103.912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M152.196,102.264c-0.126-1.199-1.201-2.07-2.4-1.944c-1.199,0.126-2.069,1.201-1.943,2.4 c0.081,0.768,0.832,7.919,0.913,8.687c0.126,1.199,1.201,2.069,2.4,1.943c1.2-0.126,2.07-1.201,1.944-2.4 C153.045,110.336,152.261,102.878,152.196,102.264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M167.883,100.615c-0.126-1.199-1.201-2.07-2.4-1.943c-1.199,0.126-2.069,1.201-1.943,2.4 c0.081,0.768,0.832,7.919,0.913,8.687c0.126,1.199,1.201,2.07,2.4,1.944c1.2-0.126,2.07-1.201,1.944-2.4 C168.731,108.687,167.947,101.23,167.883,100.615z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "185.611,185.544 104.111,194.11 94.541,126.016 176.041,117.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    points: "185.611,185.544 104.111,194.11 94.541,126.016 176.041,117.45  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "159.594,136.154 119.25,140.394 117.566,128.41 157.91,124.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    points: "159.594,136.154 119.25,140.394 117.566,128.41 157.91,124.17  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "114.634,156.587 103.858,157.72 102.35,146.984 113.125,145.852  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "129.92,154.981 119.144,156.113 117.635,145.377 128.411,144.245  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "116.669,171.068 105.894,172.2 104.385,161.465 115.16,160.332  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "118.704,185.549 107.929,186.681 106.42,175.945 117.195,174.813  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "131.955,169.461 121.179,170.594 119.671,159.858 130.446,158.726  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    points: "131.955,169.461 121.179,170.594 119.671,159.858 130.446,158.726  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "147.24,167.855 136.465,168.987 134.956,158.251 145.732,157.119  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    points: "147.24,167.855 136.465,168.987 134.956,158.251 145.732,157.119  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "162.526,166.248 151.751,167.381 150.242,156.645 161.018,155.512  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    points: "162.526,166.248 151.751,167.381 150.242,156.645 161.018,155.512  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "177.812,164.641 167.037,165.774 165.528,155.038 176.303,153.906  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    points: "177.812,164.641 167.037,165.774 165.528,155.038 176.303,153.906  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "133.99,183.942 123.215,185.074 121.706,174.339 132.481,173.206  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    points: "133.99,183.942 123.215,185.074 121.706,174.339 132.481,173.206  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "149.276,182.335 138.5,183.468 136.992,172.732 147.767,171.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    points: "149.276,182.335 138.5,183.468 136.992,172.732 147.767,171.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "164.561,180.729 153.786,181.861 152.277,171.126 163.053,169.993  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    points: "164.561,180.729 153.786,181.861 152.277,171.126 163.053,169.993  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "145.205,153.374 134.43,154.507 132.921,143.771 143.697,142.638  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "145.205,153.374 134.43,154.507 132.921,143.771 143.697,142.638  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    points: "145.205,153.374 134.43,154.507 132.921,143.771 143.697,142.638  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "160.491,151.767 149.716,152.9 148.207,142.164 158.982,141.032  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "160.491,151.767 149.716,152.9 148.207,142.164 158.982,141.032  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    points: "160.491,151.767 149.716,152.9 148.207,142.164 158.982,141.032  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none"
    },
    points: "175.777,150.161 165.002,151.293 163.493,140.558 174.268,139.425  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "175.777,150.161 165.002,151.293 163.493,140.558 174.268,139.425  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    points: "175.777,150.161 165.002,151.293 163.493,140.558 174.268,139.425  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "179.847,179.122 169.072,180.255 167.563,169.519 178.339,168.387  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M208.115,78.979c0.254,1.055-0.396,2.117-1.451,2.37c-1.055,0.254-2.116-0.396-2.37-1.451 c-0.06-0.247-0.3-1.247-0.589-2.447l-9.981,2.4c0.296,1.231,0.54,2.248,0.589,2.447c0.254,1.055-0.396,2.117-1.451,2.37 c-1.055,0.254-2.116-0.396-2.37-1.451c-0.06-0.247-0.3-1.247-0.589-2.447l-9.98,2.4c0.296,1.231,0.541,2.248,0.589,2.447 c0.254,1.055-0.396,2.117-1.452,2.37c-1.055,0.254-2.117-0.396-2.37-1.451c-0.06-0.247-0.3-1.247-0.589-2.447l-9.98,2.4 c0.296,1.231,0.541,2.248,0.589,2.447c0.254,1.055-0.396,2.117-1.451,2.37c-1.055,0.254-2.117-0.396-2.37-1.451 c-0.059-0.247-0.3-1.247-0.589-2.447l-9.981,2.4c0.296,1.231,0.54,2.248,0.589,2.447c0.254,1.055-0.396,2.117-1.451,2.37 c-1.055,0.254-2.116-0.396-2.37-1.451c-0.059-0.247-0.3-1.247-0.589-2.447l-6.34,1.525l15.712,65.332l71.71-17.245 l-15.712-65.332l-6.34,1.525C207.822,77.763,208.067,78.78,208.115,78.979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M208.115,78.979c0.254,1.055-0.396,2.117-1.451,2.37 c-1.055,0.254-2.116-0.396-2.37-1.451c-0.06-0.247-0.3-1.247-0.589-2.447l-9.981,2.4c0.296,1.231,0.54,2.248,0.589,2.447 c0.254,1.055-0.396,2.117-1.451,2.37c-1.055,0.254-2.116-0.396-2.37-1.451c-0.06-0.247-0.3-1.247-0.589-2.447l-9.98,2.4 c0.296,1.231,0.541,2.248,0.589,2.447c0.254,1.055-0.396,2.117-1.452,2.37c-1.055,0.254-2.117-0.396-2.37-1.451 c-0.06-0.247-0.3-1.247-0.589-2.447l-9.98,2.4c0.296,1.231,0.541,2.248,0.589,2.447c0.254,1.055-0.396,2.117-1.451,2.37 c-1.055,0.254-2.117-0.396-2.37-1.451c-0.059-0.247-0.3-1.247-0.589-2.447l-9.981,2.4c0.296,1.231,0.54,2.248,0.589,2.447 c0.254,1.055-0.396,2.117-1.451,2.37c-1.055,0.254-2.116-0.396-2.37-1.451c-0.059-0.247-0.3-1.247-0.589-2.447l-6.34,1.525 l15.712,65.332l71.71-17.245l-15.712-65.332l-6.34,1.525C207.822,77.763,208.067,78.78,208.115,78.979z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 164.852,
    y: 92.49,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -17.8229 45.5294)",
    style: {
      fill: "#407BFF"
    },
    width: 36.51,
    height: 10.885
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.852,
    y: 92.49,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -17.8229 45.5294)",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    width: 36.51,
    height: 10.885
  })), /*#__PURE__*/React.createElement("rect", {
    x: 153.186,
    y: 114.123,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -23.4434 40.258)",
    style: {
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.636,
    y: 110.889,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -22.3137 43.3118)",
    style: {
      fill: "#407BFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.085,
    y: 107.655,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -21.1846 46.3669)",
    style: {
      fill: "#407BFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.535,
    y: 104.42,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -20.0554 49.4215)",
    style: {
      fill: "#407BFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.985,
    y: 101.186,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -18.9264 52.4771)",
    style: {
      fill: "#407BFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.262,
    y: 126.912,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -26.3484 41.3317)",
    style: {
      fill: "#407BFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.711,
    y: 123.677,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -25.2186 44.3853)",
    style: {
      fill: "#407BFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.161,
    y: 120.443,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -24.0903 47.4426)",
    style: {
      fill: "#407BFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.61,
    y: 117.208,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -22.9602 50.495)",
    style: {
      fill: "#407BFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.06,
    y: 113.974,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -21.8313 53.5507)",
    style: {
      fill: "#407BFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.337,
    y: 139.7,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -29.2523 42.4033)",
    style: {
      fill: "#407BFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.787,
    y: 136.465,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -28.1235 45.4589)",
    style: {
      fill: "#407BFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.236,
    y: 133.231,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -26.995 48.5157)",
    style: {
      fill: "#407BFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 166.636,
    y: 110.889,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -22.3137 43.3118)",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.085,
    y: 107.655,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -21.1846 46.3669)",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.535,
    y: 104.42,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -20.0554 49.4215)",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.985,
    y: 101.186,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -18.9264 52.4771)",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.711,
    y: 123.677,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -25.2186 44.3853)",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.161,
    y: 120.443,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -24.0903 47.4426)",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.61,
    y: 117.208,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -22.9602 50.495)",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.06,
    y: 113.974,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -21.8313 53.5507)",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.787,
    y: 136.465,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -28.1235 45.4589)",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.236,
    y: 133.231,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -26.995 48.5157)",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  })), /*#__PURE__*/React.createElement("rect", {
    x: 199.686,
    y: 129.996,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -25.8653 51.5691)",
    style: {
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.135,
    y: 126.762,
    transform: "matrix(0.9723 -0.2338 0.2338 0.9723 -24.7362 54.6243)",
    style: {
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "142.156,92.253 156.057,160.131 229.577,140.34 157.868,157.585  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "142.156,92.253 156.057,160.131 229.577,140.34 157.868,157.585  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M207.737,52.719c0.549,0.936,0.235,2.14-0.701,2.69c-0.936,0.549-2.14,0.235-2.689-0.701 c-0.129-0.22-0.649-1.106-1.273-2.171l-8.854,5.194c0.641,1.092,1.17,1.994,1.273,2.171c0.549,0.936,0.236,2.14-0.701,2.69 c-0.936,0.549-2.14,0.235-2.689-0.701c-0.129-0.22-0.649-1.106-1.273-2.171l-8.854,5.194c0.641,1.092,1.17,1.994,1.273,2.171 c0.549,0.936,0.236,2.14-0.701,2.69c-0.936,0.549-2.14,0.235-2.689-0.701c-0.129-0.219-0.649-1.106-1.273-2.171l-8.854,5.194 c0.641,1.092,1.17,1.994,1.273,2.171c0.549,0.936,0.235,2.14-0.701,2.69c-0.936,0.549-2.14,0.235-2.689-0.701 c-0.129-0.219-0.649-1.106-1.273-2.171l-8.854,5.194c0.641,1.092,1.17,1.994,1.273,2.171c0.549,0.936,0.236,2.14-0.701,2.69 c-0.936,0.549-2.14,0.235-2.689-0.701c-0.129-0.22-0.649-1.106-1.273-2.171l-5.624,3.299l33.999,57.959l63.617-37.317 l-33.999-57.959l-5.624,3.299C207.104,51.64,207.633,52.542,207.737,52.719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M207.737,52.719c0.549,0.936,0.235,2.14-0.701,2.69 c-0.936,0.549-2.14,0.235-2.689-0.701c-0.129-0.22-0.649-1.106-1.273-2.171l-8.854,5.194c0.641,1.092,1.17,1.994,1.273,2.171 c0.549,0.936,0.236,2.14-0.701,2.69c-0.936,0.549-2.14,0.235-2.689-0.701c-0.129-0.22-0.649-1.106-1.273-2.171l-8.854,5.194 c0.641,1.092,1.17,1.994,1.273,2.171c0.549,0.936,0.236,2.14-0.701,2.69c-0.936,0.549-2.14,0.235-2.689-0.701 c-0.129-0.219-0.649-1.106-1.273-2.171l-8.854,5.194c0.641,1.092,1.17,1.994,1.273,2.171c0.549,0.936,0.235,2.14-0.701,2.69 c-0.936,0.549-2.14,0.235-2.689-0.701c-0.129-0.219-0.649-1.106-1.273-2.171l-8.854,5.194c0.641,1.092,1.17,1.994,1.273,2.171 c0.549,0.936,0.236,2.14-0.701,2.69c-0.936,0.549-2.14,0.235-2.689-0.701c-0.129-0.22-0.649-1.106-1.273-2.171l-5.624,3.299 l33.999,57.959l63.617-37.317l-33.999-57.959l-5.624,3.299C207.104,51.64,207.633,52.542,207.737,52.719z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 171.052,
    y: 72.672,
    transform: "matrix(0.8626 -0.506 0.506 0.8626 -13.5037 106.5205)",
    style: {
      fill: "#407BFF"
    },
    width: 36.51,
    height: 10.885
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.052,
    y: 72.672,
    transform: "matrix(0.8626 -0.506 0.506 0.8626 -13.5037 106.5205)",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    width: 36.51,
    height: 10.885
  })), /*#__PURE__*/React.createElement("rect", {
    x: 166.58,
    y: 100.669,
    transform: "matrix(0.8626 -0.506 0.506 0.8626 -29.8359 101.2579)",
    style: {
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.511,
    y: 93.67,
    transform: "matrix(0.8626 -0.506 0.506 0.8626 -24.6545 106.333)",
    style: {
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.443,
    y: 86.67,
    transform: "matrix(0.8626 -0.506 0.506 0.8626 -19.4734 111.4061)",
    style: {
      fill: "#407BFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.375,
    y: 79.671,
    transform: "matrix(0.8626 -0.506 0.506 0.8626 -14.2922 116.4811)",
    style: {
      fill: "#407BFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.306,
    y: 72.672,
    transform: "matrix(0.8625 -0.506 0.506 0.8625 -9.1104 121.5593)",
    style: {
      fill: "#407BFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.234,
    y: 112.013,
    transform: "matrix(0.8625 -0.506 0.506 0.8625 -34.6614 106.1855)",
    style: {
      fill: "#407BFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.166,
    y: 105.014,
    transform: "matrix(0.8625 -0.506 0.506 0.8625 -29.48 111.2606)",
    style: {
      fill: "#407BFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.098,
    y: 98.015,
    transform: "matrix(0.8625 -0.506 0.506 0.8625 -24.2986 116.3357)",
    style: {
      fill: "#407BFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.03,
    y: 91.016,
    transform: "matrix(0.8626 -0.506 0.506 0.8626 -19.1175 121.4087)",
    style: {
      fill: "#407BFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.961,
    y: 84.017,
    transform: "matrix(0.8626 -0.506 0.506 0.8626 -13.9364 126.4825)",
    style: {
      fill: "#407BFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.889,
    y: 123.358,
    transform: "matrix(0.8626 -0.506 0.506 0.8626 -39.4868 111.1109)",
    style: {
      fill: "#407BFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.821,
    y: 116.359,
    transform: "matrix(0.8626 -0.506 0.506 0.8626 -34.3055 116.186)",
    style: {
      fill: "#407BFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.753,
    y: 109.36,
    transform: "matrix(0.8626 -0.506 0.506 0.8626 -29.1242 121.261)",
    style: {
      fill: "#407BFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 190.443,
    y: 86.67,
    transform: "matrix(0.8626 -0.506 0.506 0.8626 -19.4734 111.4061)",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.375,
    y: 79.671,
    transform: "matrix(0.8626 -0.506 0.506 0.8626 -14.2922 116.4811)",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.306,
    y: 72.672,
    transform: "matrix(0.8625 -0.506 0.506 0.8625 -9.1104 121.5593)",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.166,
    y: 105.014,
    transform: "matrix(0.8625 -0.506 0.506 0.8625 -29.48 111.2606)",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.098,
    y: 98.015,
    transform: "matrix(0.8625 -0.506 0.506 0.8625 -24.2986 116.3357)",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.03,
    y: 91.016,
    transform: "matrix(0.8626 -0.506 0.506 0.8626 -19.1175 121.4087)",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.961,
    y: 84.017,
    transform: "matrix(0.8626 -0.506 0.506 0.8626 -13.9364 126.4825)",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.821,
    y: 116.359,
    transform: "matrix(0.8626 -0.506 0.506 0.8626 -34.3055 116.186)",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.753,
    y: 109.36,
    transform: "matrix(0.8626 -0.506 0.506 0.8626 -29.1242 121.261)",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  })), /*#__PURE__*/React.createElement("rect", {
    x: 215.684,
    y: 102.361,
    transform: "matrix(0.8626 -0.506 0.506 0.8626 -23.9428 126.3361)",
    style: {
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.616,
    y: 95.362,
    transform: "matrix(0.8626 -0.506 0.506 0.8626 -18.7618 131.4089)",
    style: {
      fill: "#FFFFFF"
    },
    width: 9.751,
    height: 9.751
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "148.399,84.608 181.403,145.529 246.014,105.25 182.398,142.567  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "148.399,84.608 181.403,145.529 246.014,105.25 182.398,142.567  "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Seasons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M400.055,288.803l-30.207-4.565c-10.313-1.559-17.409-11.182-15.851-21.495l4.565-30.206 c1.559-10.313,11.182-17.409,21.495-15.851l30.207,4.565c10.313,1.559,17.409,11.182,15.851,21.495l-4.565,30.207 C419.991,283.265,410.367,290.362,400.055,288.803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M400.055,288.803l-30.207-4.565c-10.313-1.559-17.409-11.182-15.851-21.495 l4.565-30.206c1.559-10.313,11.182-17.409,21.495-15.851l30.207,4.565c10.313,1.559,17.409,11.182,15.851,21.495l-4.565,30.207 C419.991,283.265,410.367,290.362,400.055,288.803z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M370.654,241.816c0,0-4.074-6.481,0.061-10.374l3.109,2.05c0,0-2.962,3.943-1.24,7.946 L370.654,241.816z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M377.66,237.219c-2.432,0.478-4.618,1.522-6.493,2.967c-2.283-0.628-4.701-0.767-7.133-0.289 c-9.126,1.794-14.927,11.375-12.957,21.401c1.971,10.026,10.966,16.699,20.093,14.905c2.432-0.478,4.617-1.522,6.493-2.967 c2.283,0.628,4.701,0.767,7.133,0.289c9.126-1.794,14.927-11.375,12.957-21.401C395.782,242.098,386.786,235.425,377.66,237.219 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    d: "M377.66,237.219c-2.432,0.478-4.618,1.522-6.493,2.967 c-2.283-0.628-4.701-0.767-7.133-0.289c-9.126,1.794-14.927,11.375-12.957,21.401c1.971,10.026,10.966,16.699,20.093,14.905 c2.432-0.478,4.617-1.522,6.493-2.967c2.283,0.628,4.701,0.767,7.133,0.289c9.126-1.794,14.927-11.375,12.957-21.401 C395.782,242.098,386.786,235.425,377.66,237.219z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M377.66,237.219c-2.432,0.478-4.618,1.522-6.493,2.967l6.496,33.05 c2.283,0.628,4.701,0.767,7.133,0.289c9.126-1.794,14.927-11.375,12.957-21.401C395.782,242.098,386.786,235.425,377.66,237.219 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M377.66,237.219c-2.432,0.478-4.618,1.522-6.493,2.967l6.496,33.05 c2.283,0.628,4.701,0.767,7.133,0.289c9.126-1.794,14.927-11.375,12.957-21.401C395.782,242.098,386.786,235.425,377.66,237.219 z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "365.751,252.846 367.252,253.564 370.423,252.941 364.561,246.795 361.462,254.702  364.633,254.079  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "381.668,249.717 383.169,250.435 386.34,249.812 380.478,243.666 377.379,251.574  380.55,250.95  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M372.523,261.266l-0.036,2.176l-4.746-0.468l0.698-1.615c-3.502-0.129-5.815-0.741-5.815-0.741 s4.032,8.59,13.893,6.792c1.656-0.302,3.047-0.845,4.246-1.518l-1.855-2.033l3.999-3.167l1.2,2.473 c2.922-3.387,3.397-7.437,3.397-7.437C382.514,259.506,377.055,260.891,372.523,261.266z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M402.441,236.363l-4.379,3.059l8.672,0.962c1.655,0.184,3.053-1.215,2.869-2.869l-0.962-8.672 l-3.059,4.379l-2.482,0.66L402.441,236.363z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M419.685,253.607l-3.059,4.379l-0.962-8.672c-0.184-1.655,1.215-3.053,2.869-2.869l8.672,0.962 l-4.379,3.059l-0.66,2.482L419.685,253.607z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M416.409,247.189c-2.085,2.085-5.465,2.085-7.551,0c-2.085-2.085-2.085-5.465,0-7.551 c2.085-2.085,5.466-2.085,7.551,0C418.494,241.724,418.494,245.104,416.409,247.189z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M402.441,236.363l-4.379,3.059l8.672,0.962c1.655,0.184,3.053-1.215,2.869-2.869l-0.962-8.672 l-3.059,4.379l-2.482,0.66L402.441,236.363z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M419.685,253.607l-3.059,4.379l-0.962-8.672c-0.184-1.655,1.215-3.053,2.869-2.869l8.672,0.962 l-4.379,3.059l-0.66,2.482L419.685,253.607z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M416.409,247.189c-2.085,2.085-5.465,2.085-7.551,0c-2.085-2.085-2.085-5.465,0-7.551 c2.085-2.085,5.466-2.085,7.551,0C418.494,241.724,418.494,245.104,416.409,247.189z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M414.227,238.32c-1.835-0.572-3.916-0.135-5.369,1.318c-0.818,0.818-1.31,1.837-1.486,2.897 L414.227,238.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M408.858,247.189c0.487,0.487,1.047,0.856,1.642,1.115l7.457-4.586 c0.047-0.819-0.093-1.645-0.422-2.412l-8.995,5.531C408.642,246.958,408.746,247.077,408.858,247.189z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M400.174,267.04l-0.773,4.353l5.639-4.513c1.076-0.861,1.076-2.498,0-3.359l-5.639-4.513 l0.773,4.353l-1.066,1.839L400.174,267.04z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M420.36,267.04l0.773,4.353l-5.639-4.513c-1.076-0.861-1.076-2.498,0-3.359l5.639-4.513 l-0.773,4.353l1.066,1.839L420.36,267.04z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M414.687,265.201c0,2.441-1.979,4.42-4.42,4.42s-4.419-1.979-4.419-4.42 c0-2.441,1.979-4.419,4.419-4.419S414.687,262.76,414.687,265.201z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M400.174,267.04l-0.773,4.353l5.639-4.513c1.076-0.861,1.076-2.498,0-3.359l-5.639-4.513 l0.773,4.353l-1.066,1.839L400.174,267.04z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M420.36,267.04l0.773,4.353l-5.639-4.513c-1.076-0.861-1.076-2.498,0-3.359l5.639-4.513 l-0.773,4.353l1.066,1.839L420.36,267.04z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M414.687,265.201c0,2.441-1.979,4.42-4.42,4.42s-4.419-1.979-4.419-4.42 c0-2.441,1.979-4.419,4.419-4.419S414.687,262.76,414.687,265.201z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M408.219,261.287c-1.409,0.739-2.371,2.213-2.371,3.914c0,0.958,0.308,1.842,0.826,2.566 L408.219,261.287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M410.267,269.621c0.57,0,1.113-0.112,1.614-0.308l1.681-7.049 c-0.452-0.507-1.017-0.909-1.658-1.165l-2.028,8.503C410.005,269.612,410.135,269.621,410.267,269.621z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M407.076,160.205l-46.832,9.556c-10.219,2.085-20.194-4.509-22.279-14.728l-9.556-46.832 c-2.085-10.219,4.509-20.194,14.728-22.279l46.832-9.556c10.219-2.085,20.194,4.509,22.279,14.728l9.556,46.832 C423.889,148.145,417.295,158.12,407.076,160.205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M407.076,160.205l-46.832,9.556c-10.219,2.085-20.194-4.509-22.279-14.728 l-9.556-46.832c-2.085-10.219,4.509-20.194,14.728-22.279l46.832-9.556c10.219-2.085,20.194,4.509,22.279,14.728l9.556,46.832 C423.889,148.145,417.295,158.12,407.076,160.205z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M403.1,96.324c-1.988,0.268-3.975,0.537-5.963,0.805c1.072-1.406,2.144-2.813,3.215-4.219 c0.409-0.536-0.423-1.17-0.832-0.634c-1.283,1.684-2.566,3.367-3.849,5.051c-1.921,0.259-3.842,0.519-5.763,0.778 c0.116-0.177,0.219-0.338,0.286-0.425c0.728-0.956,1.456-1.911,2.185-2.867c1.093-1.434,2.186-2.868,3.278-4.302 c0.409-0.536-0.423-1.17-0.832-0.634c-2.142,2.811-4.284,5.621-6.425,8.432c-0.795,0.107-1.589,0.215-2.384,0.322 c-0.107-0.795-0.215-1.589-0.322-2.383c2.142-2.811,4.284-5.621,6.425-8.432c0.409-0.536-0.423-1.17-0.831-0.634 c-1.032,1.354-2.064,2.709-3.096,4.063c-0.789,1.035-1.578,2.071-2.367,3.106c-0.07,0.091-0.197,0.232-0.334,0.387 c-0.259-1.921-0.519-3.841-0.778-5.762c1.283-1.684,2.566-3.367,3.849-5.051c0.409-0.536-0.423-1.17-0.832-0.634 c-1.072,1.406-2.143,2.813-3.215,4.219c-0.268-1.987-0.537-3.975-0.805-5.963c-0.09-0.667-1.127-0.528-1.036,0.14 c0.268,1.988,0.537,3.975,0.805,5.963c-1.406-1.072-2.813-2.144-4.219-3.215c-0.536-0.408-1.17,0.423-0.634,0.832 c1.684,1.283,3.367,2.566,5.051,3.849c0.259,1.921,0.519,3.842,0.778,5.763c-0.177-0.116-0.338-0.219-0.425-0.285 c-0.956-0.728-1.911-1.457-2.867-2.185c-1.434-1.093-2.868-2.186-4.302-3.278c-0.536-0.408-1.17,0.423-0.634,0.832 c2.811,2.142,5.621,4.284,8.432,6.425c0.107,0.795,0.214,1.589,0.322,2.383c-0.794,0.107-1.589,0.215-2.383,0.322 c-2.811-2.142-5.621-4.284-8.431-6.425c-0.536-0.409-1.17,0.423-0.634,0.832c1.354,1.032,2.709,2.064,4.063,3.096 c1.035,0.789,2.07,1.578,3.105,2.367c0.092,0.07,0.232,0.196,0.387,0.334c-1.921,0.259-3.841,0.519-5.762,0.778 c-1.684-1.283-3.367-2.566-5.051-3.849c-0.536-0.408-1.17,0.423-0.634,0.832c1.406,1.072,2.813,2.144,4.219,3.215 c-1.988,0.268-3.975,0.537-5.963,0.805c-0.667,0.09-0.528,1.126,0.14,1.036c1.988-0.268,3.975-0.537,5.963-0.805 c-1.072,1.406-2.143,2.813-3.215,4.219c-0.409,0.536,0.423,1.17,0.832,0.634c1.283-1.684,2.566-3.367,3.849-5.051 c1.921-0.259,3.842-0.519,5.763-0.778c-0.116,0.177-0.219,0.338-0.286,0.425c-0.728,0.956-1.457,1.911-2.185,2.867 c-1.093,1.434-2.186,2.868-3.278,4.302c-0.409,0.536,0.423,1.17,0.832,0.634c2.142-2.811,4.284-5.621,6.426-8.432 c0.794-0.107,1.589-0.215,2.383-0.322c0.107,0.795,0.214,1.589,0.322,2.383c-2.142,2.811-4.284,5.621-6.426,8.432 c-0.408,0.536,0.423,1.17,0.832,0.634c1.032-1.354,2.064-2.709,3.096-4.063c0.789-1.035,1.578-2.07,2.367-3.106 c0.07-0.091,0.196-0.232,0.334-0.387c0.259,1.921,0.519,3.841,0.778,5.762c-1.283,1.683-2.566,3.367-3.849,5.051 c-0.409,0.536,0.423,1.17,0.832,0.634c1.072-1.406,2.143-2.813,3.215-4.219c0.268,1.987,0.537,3.975,0.805,5.963 c0.09,0.667,1.126,0.528,1.036-0.14c-0.268-1.988-0.537-3.975-0.805-5.963c1.406,1.072,2.813,2.144,4.219,3.215 c0.536,0.408,1.17-0.423,0.634-0.832c-1.683-1.283-3.367-2.566-5.051-3.849c-0.259-1.921-0.519-3.842-0.778-5.763 c0.177,0.116,0.338,0.219,0.425,0.285c0.956,0.728,1.911,1.457,2.867,2.185c1.434,1.093,2.868,2.186,4.302,3.278 c0.536,0.409,1.17-0.423,0.634-0.832c-2.81-2.142-5.621-4.284-8.431-6.425c-0.107-0.795-0.215-1.589-0.322-2.384 c0.794-0.107,1.589-0.215,2.383-0.322c2.811,2.142,5.621,4.284,8.432,6.426c0.536,0.408,1.17-0.423,0.634-0.832 c-1.354-1.032-2.709-2.064-4.063-3.096c-1.035-0.789-2.071-1.578-3.106-2.367c-0.091-0.07-0.232-0.196-0.387-0.334 c1.921-0.259,3.841-0.519,5.762-0.778c1.683,1.283,3.367,2.566,5.051,3.849c0.536,0.408,1.17-0.423,0.634-0.832 c-1.406-1.072-2.813-2.144-4.219-3.215c1.988-0.268,3.975-0.537,5.963-0.805C403.907,97.271,403.768,96.234,403.1,96.324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M415.491,125.23c-0.949-0.723-1.897-1.446-2.845-2.168c1.042-0.141,2.084-0.281,3.125-0.422 c0.397-0.053,0.314-0.67-0.083-0.616c-1.247,0.168-2.495,0.337-3.742,0.505c-0.917-0.698-1.833-1.397-2.75-2.096 c0.124-0.026,0.234-0.05,0.299-0.059c0.708-0.096,1.416-0.191,2.124-0.287c1.062-0.143,2.125-0.287,3.187-0.43 c0.397-0.053,0.314-0.67-0.083-0.616c-2.082,0.281-4.164,0.562-6.246,0.843c-0.379-0.289-0.758-0.578-1.137-0.867 c0.289-0.379,0.578-0.758,0.867-1.137c2.082-0.281,4.164-0.562,6.246-0.843c0.397-0.054,0.314-0.67-0.083-0.616 c-1.003,0.135-2.007,0.271-3.01,0.406c-0.767,0.104-1.534,0.207-2.301,0.311c-0.068,0.009-0.18,0.015-0.303,0.022 c0.699-0.916,1.397-1.833,2.095-2.749c1.247-0.168,2.495-0.337,3.742-0.505c0.397-0.054,0.314-0.67-0.083-0.616 c-1.042,0.141-2.084,0.281-3.125,0.422c0.723-0.948,1.446-1.897,2.168-2.845c0.242-0.318-0.252-0.696-0.495-0.377 c-0.723,0.949-1.446,1.897-2.169,2.845c-0.141-1.042-0.281-2.084-0.422-3.125c-0.053-0.397-0.67-0.314-0.616,0.083 c0.168,1.247,0.337,2.494,0.505,3.742c-0.699,0.917-1.397,1.833-2.096,2.75c-0.026-0.123-0.05-0.234-0.059-0.299 c-0.096-0.708-0.191-1.416-0.287-2.124c-0.143-1.062-0.287-2.125-0.43-3.187c-0.054-0.397-0.67-0.314-0.616,0.083 c0.281,2.082,0.562,4.164,0.843,6.246c-0.289,0.379-0.578,0.758-0.867,1.137c-0.379-0.289-0.758-0.578-1.137-0.867 c-0.281-2.082-0.562-4.164-0.843-6.246c-0.054-0.397-0.67-0.314-0.616,0.083c0.135,1.003,0.271,2.007,0.406,3.01 c0.103,0.767,0.207,1.534,0.311,2.301c0.009,0.068,0.015,0.18,0.022,0.303c-0.917-0.698-1.833-1.397-2.749-2.095 c-0.168-1.247-0.337-2.494-0.505-3.742c-0.054-0.397-0.67-0.314-0.616,0.083c0.141,1.042,0.281,2.084,0.422,3.125 c-0.949-0.723-1.897-1.446-2.845-2.168c-0.318-0.243-0.696,0.252-0.377,0.494c0.948,0.723,1.897,1.446,2.845,2.168 c-1.042,0.141-2.084,0.281-3.126,0.422c-0.397,0.054-0.314,0.67,0.083,0.616c1.247-0.168,2.494-0.337,3.742-0.505 c0.917,0.699,1.833,1.397,2.75,2.096c-0.123,0.026-0.234,0.05-0.299,0.059c-0.708,0.096-1.416,0.191-2.124,0.287 c-1.062,0.144-2.125,0.287-3.187,0.43c-0.397,0.054-0.314,0.67,0.083,0.616c2.082-0.281,4.164-0.562,6.246-0.843 c0.379,0.289,0.758,0.578,1.137,0.867c-0.289,0.379-0.578,0.758-0.867,1.137c-2.082,0.281-4.164,0.562-6.246,0.843 c-0.397,0.054-0.314,0.67,0.083,0.616c1.003-0.135,2.007-0.271,3.01-0.406c0.767-0.104,1.534-0.207,2.301-0.311 c0.068-0.009,0.18-0.015,0.303-0.022c-0.698,0.916-1.397,1.833-2.095,2.749c-1.247,0.168-2.494,0.337-3.742,0.505 c-0.397,0.054-0.314,0.67,0.083,0.616c1.042-0.141,2.084-0.281,3.125-0.422c-0.723,0.949-1.446,1.897-2.168,2.845 c-0.242,0.318,0.252,0.696,0.495,0.377c0.723-0.948,1.446-1.897,2.168-2.845c0.141,1.042,0.281,2.084,0.422,3.126 c0.054,0.397,0.67,0.314,0.616-0.083c-0.168-1.247-0.337-2.494-0.505-3.742c0.698-0.917,1.397-1.833,2.096-2.75 c0.026,0.123,0.05,0.234,0.059,0.299c0.096,0.708,0.191,1.416,0.287,2.124c0.143,1.062,0.287,2.125,0.43,3.187 c0.053,0.397,0.67,0.314,0.616-0.083c-0.281-2.082-0.562-4.164-0.843-6.246c0.289-0.379,0.578-0.758,0.867-1.137 c0.379,0.289,0.758,0.578,1.137,0.867c0.281,2.082,0.562,4.164,0.843,6.246c0.054,0.397,0.67,0.314,0.616-0.083 c-0.135-1.003-0.271-2.007-0.406-3.01c-0.104-0.767-0.207-1.534-0.311-2.301c-0.009-0.068-0.015-0.18-0.022-0.304 c0.917,0.699,1.833,1.397,2.75,2.095c0.168,1.247,0.337,2.494,0.505,3.742c0.054,0.397,0.67,0.314,0.616-0.083 c-0.141-1.042-0.281-2.084-0.422-3.125c0.948,0.723,1.897,1.446,2.845,2.168C415.433,125.967,415.81,125.473,415.491,125.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M388.989,138.742c0.095-0.703,0.19-1.405,0.285-2.108c-0.497,0.379-0.994,0.758-1.491,1.137 c-0.189,0.144-0.414-0.15-0.224-0.294c0.595-0.453,1.19-0.907,1.786-1.361c0.092-0.679,0.183-1.358,0.275-2.037 c-0.063,0.041-0.12,0.077-0.15,0.101c-0.338,0.257-0.676,0.515-1.013,0.772c-0.507,0.386-1.014,0.773-1.521,1.159 c-0.189,0.145-0.414-0.15-0.224-0.294c0.994-0.757,1.987-1.514,2.981-2.271c0.038-0.281,0.076-0.562,0.114-0.843 c-0.281-0.038-0.562-0.076-0.843-0.114c-0.993,0.757-1.987,1.514-2.981,2.271c-0.19,0.145-0.414-0.15-0.224-0.294 c0.479-0.365,0.958-0.73,1.436-1.095c0.366-0.279,0.732-0.558,1.098-0.837c0.032-0.025,0.082-0.069,0.137-0.118 c-0.679-0.092-1.358-0.183-2.037-0.275c-0.595,0.454-1.19,0.907-1.785,1.361c-0.189,0.144-0.414-0.15-0.224-0.294 c0.497-0.379,0.994-0.758,1.492-1.137c-0.703-0.095-1.405-0.19-2.108-0.285c-0.236-0.032-0.187-0.398,0.049-0.366 c0.703,0.095,1.405,0.19,2.108,0.285c-0.379-0.497-0.758-0.994-1.137-1.491c-0.144-0.189,0.15-0.414,0.294-0.224 c0.453,0.595,0.907,1.19,1.361,1.785c0.679,0.092,1.358,0.183,2.037,0.275c-0.041-0.063-0.078-0.12-0.101-0.15 c-0.257-0.338-0.515-0.676-0.772-1.014c-0.386-0.507-0.773-1.014-1.159-1.521c-0.144-0.189,0.149-0.414,0.294-0.224 c0.757,0.994,1.514,1.987,2.272,2.981c0.281,0.038,0.562,0.076,0.843,0.114c0.038-0.281,0.076-0.562,0.114-0.843 c-0.757-0.994-1.514-1.987-2.272-2.981c-0.144-0.189,0.15-0.413,0.294-0.224c0.365,0.479,0.73,0.958,1.095,1.436 c0.279,0.366,0.558,0.732,0.837,1.098c0.025,0.032,0.069,0.082,0.118,0.137c0.092-0.679,0.183-1.358,0.275-2.037 c-0.454-0.595-0.907-1.19-1.361-1.785c-0.144-0.19,0.15-0.414,0.294-0.224c0.379,0.497,0.758,0.994,1.137,1.492 c0.095-0.703,0.19-1.405,0.285-2.108c0.032-0.236,0.398-0.187,0.366,0.05c-0.095,0.703-0.19,1.405-0.285,2.108 c0.497-0.379,0.994-0.758,1.491-1.137c0.189-0.144,0.414,0.149,0.224,0.294c-0.595,0.453-1.19,0.907-1.785,1.361 c-0.092,0.679-0.183,1.358-0.275,2.037c0.063-0.041,0.12-0.077,0.15-0.101c0.338-0.257,0.676-0.515,1.013-0.772 c0.507-0.386,1.014-0.773,1.521-1.159c0.189-0.144,0.414,0.15,0.224,0.294c-0.993,0.757-1.987,1.514-2.981,2.272 c-0.038,0.281-0.076,0.562-0.114,0.842c0.281,0.038,0.562,0.076,0.843,0.114c0.994-0.757,1.987-1.514,2.981-2.272 c0.189-0.144,0.414,0.15,0.224,0.294c-0.479,0.365-0.957,0.73-1.436,1.095c-0.366,0.279-0.732,0.558-1.098,0.837 c-0.032,0.025-0.082,0.07-0.137,0.118c0.679,0.092,1.358,0.183,2.037,0.275c0.595-0.454,1.19-0.907,1.785-1.361 c0.189-0.145,0.414,0.15,0.224,0.294c-0.497,0.379-0.994,0.758-1.491,1.137c0.703,0.095,1.405,0.19,2.108,0.285 c0.236,0.032,0.187,0.398-0.049,0.366c-0.703-0.095-1.405-0.19-2.108-0.285c0.379,0.497,0.758,0.994,1.137,1.491 c0.144,0.189-0.15,0.414-0.294,0.224c-0.453-0.595-0.907-1.19-1.361-1.786c-0.679-0.092-1.358-0.183-2.037-0.275 c0.041,0.063,0.077,0.119,0.101,0.15c0.258,0.338,0.515,0.676,0.772,1.013c0.386,0.507,0.773,1.014,1.159,1.521 c0.144,0.189-0.15,0.413-0.294,0.224c-0.757-0.993-1.514-1.987-2.271-2.98c-0.281-0.038-0.562-0.076-0.843-0.114 c-0.038,0.281-0.076,0.562-0.114,0.842c0.757,0.994,1.514,1.987,2.272,2.981c0.144,0.189-0.15,0.414-0.294,0.224 c-0.365-0.479-0.73-0.958-1.095-1.436c-0.279-0.366-0.558-0.732-0.837-1.098c-0.025-0.032-0.069-0.082-0.118-0.137 c-0.092,0.679-0.183,1.358-0.275,2.037c0.453,0.595,0.907,1.19,1.361,1.786c0.144,0.189-0.15,0.414-0.294,0.224 c-0.379-0.497-0.758-0.994-1.137-1.492c-0.095,0.703-0.19,1.405-0.285,2.108C389.323,139.027,388.957,138.978,388.989,138.742z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M368.696,128.6c0,0.682-0.553,1.235-1.235,1.235c-0.682,0-1.235-0.553-1.235-1.235 c0-0.682,0.553-1.235,1.235-1.235C368.144,127.365,368.696,127.918,368.696,128.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "360.021,164.748 360.021,149.398 352.217,149.398 352.217,164.748 348.182,169.789  353.762,168.799 356.119,170.165 358.476,168.799 364.055,169.789  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "364.849,152.56 385.514,156.228 356.119,119.496 326.724,156.228 347.39,152.56  356.119,157.621  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    points: "364.849,152.56 385.514,156.228 356.119,119.496 326.724,156.228  347.39,152.56 356.119,157.621  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "363.976,136.029 382.574,139.33 356.119,106.272 329.663,139.33 348.263,136.029  356.119,140.584  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    points: "363.976,136.029 382.574,139.33 356.119,106.272 329.663,139.33  348.263,136.029 356.119,140.584  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "361.706,118.404 374.931,120.752 356.119,97.244 337.306,120.752 350.532,118.404  356.119,121.644  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    points: "361.706,118.404 374.931,120.752 356.119,97.244 337.306,120.752  350.532,118.404 356.119,121.644  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "356.119,83.291 358.438,87.99 363.622,88.743 359.871,92.4 360.756,97.564  356.119,95.126 351.481,97.564 352.367,92.4 348.615,88.743 353.8,87.99  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M344.235,112.093c0,0,6.441,15.176,27.725,13.974 C371.961,126.067,349.515,131.788,344.235,112.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M346.832,108.848c0,0,9.897,5.573,18.107-0.583C364.939,108.266,357.37,118.733,346.832,108.848z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M373.743,128.295c0,0-12.556,14.911-31.745,8.845 C341.999,137.141,359.565,150.531,373.743,128.295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M351.729,114.544c0,0.792-0.642,1.434-1.434,1.434c-0.792,0-1.434-0.642-1.434-1.434 c0-0.792,0.642-1.434,1.434-1.434C351.087,113.11,351.729,113.752,351.729,114.544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M365.056,113.095c0,0.792-0.642,1.434-1.434,1.434c-0.792,0-1.434-0.642-1.434-1.434 c0-0.792,0.642-1.434,1.434-1.434C364.414,111.662,365.056,112.304,365.056,113.095z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M348.266,122.472c0,0.792-0.642,1.434-1.434,1.434c-0.792,0-1.434-0.642-1.434-1.434 c0-0.792,0.642-1.434,1.434-1.434C347.624,121.039,348.266,121.68,348.266,122.472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M358.753,128.295c0,0.792-0.642,1.434-1.434,1.434c-0.792,0-1.434-0.642-1.434-1.434 c0-0.792,0.642-1.434,1.434-1.434C358.111,126.862,358.753,127.504,358.753,128.295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M343.433,141.138c0,0.792-0.642,1.434-1.434,1.434c-0.792,0-1.434-0.642-1.434-1.434 c0-0.792,0.642-1.434,1.434-1.434C342.791,139.704,343.433,140.346,343.433,141.138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M355.805,144.027c0,0.792-0.642,1.434-1.434,1.434c-0.792,0-1.434-0.642-1.434-1.434 c0-0.792,0.642-1.434,1.434-1.434C355.163,142.594,355.805,143.235,355.805,144.027z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M367.462,137.903c0,0.682-0.553,1.235-1.235,1.235c-0.682,0-1.235-0.553-1.235-1.235 c0-0.682,0.553-1.235,1.235-1.235C366.909,136.668,367.462,137.221,367.462,137.903z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M174.07,316.082l-36.751-3.062c-10.394-0.866-18.118-9.994-17.252-20.388l3.062-36.75 c0.866-10.394,9.994-18.118,20.388-17.252l36.75,3.062c10.394,0.866,18.118,9.994,17.252,20.388l-3.062,36.75 C193.592,309.224,184.464,316.948,174.07,316.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M174.07,316.082l-36.751-3.062c-10.394-0.866-18.118-9.994-17.252-20.388l3.062-36.75 c0.866-10.394,9.994-18.118,20.388-17.252l36.75,3.062c10.394,0.866,18.118,9.994,17.252,20.388l-3.062,36.75 C193.592,309.224,184.464,316.948,174.07,316.082z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M181.011,308.1h-4.204c-3.498,0-6.334-2.836-6.334-6.334l1.055-28.817h14.763l1.054,28.817 C187.345,305.264,184.509,308.1,181.011,308.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M192.947,270.324c0,3.403-2.759,6.162-6.162,6.162s-6.162-2.759-6.162-6.162 c0-3.403,2.759-6.162,6.162-6.162S192.947,266.921,192.947,270.324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M192.947,270.324c0,3.403-2.759,6.162-6.162,6.162s-6.162-2.759-6.162-6.162 c0-3.403,2.759-6.162,6.162-6.162S192.947,266.921,192.947,270.324z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M187.312,265.13v4.416l3.046-3.046C189.542,265.738,188.485,265.248,187.312,265.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M185.512,270.291l-2.998-2.998c-0.604,0.849-0.966,1.879-0.973,2.998H185.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M186.258,265.13c-1.173,0.119-2.23,0.608-3.046,1.37l3.046,3.046V265.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M185.512,271.345h-3.872c0.193,0.978,0.665,1.85,1.32,2.551L185.512,271.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M188.058,271.345l2.551,2.551c0.655-0.701,1.127-1.573,1.32-2.551H188.058z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M188.058,270.291h3.972c-0.007-1.119-0.37-2.149-0.973-2.998L188.058,270.291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M186.258,272.091l-2.504,2.504c0.721,0.512,1.577,0.829,2.504,0.923V272.091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M187.312,272.091v3.427c0.927-0.094,1.783-0.411,2.504-0.923L187.312,272.091z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M187.312,265.13v4.416l3.046-3.046C189.542,265.738,188.485,265.248,187.312,265.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M185.512,270.291l-2.998-2.998c-0.604,0.849-0.966,1.879-0.973,2.998H185.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M186.258,265.13c-1.173,0.119-2.23,0.608-3.046,1.37l3.046,3.046V265.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M185.512,271.345h-3.872c0.193,0.978,0.665,1.85,1.32,2.551L185.512,271.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M188.058,271.345l2.551,2.551c0.655-0.701,1.127-1.573,1.32-2.551H188.058z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M188.058,270.291h3.972c-0.007-1.119-0.37-2.149-0.973-2.998L188.058,270.291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M186.258,272.091l-2.504,2.504c0.721,0.512,1.577,0.829,2.504,0.923V272.091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M187.312,272.091v3.427c0.927-0.094,1.783-0.411,2.504-0.923L187.312,272.091z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M185.403,277.516h-12.988l-0.889,24.288c0.001,2.873,2.369,5.242,5.28,5.242h4.205 c2.911,0,5.279-2.369,5.279-5.28L185.403,277.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M185.403,277.516h-12.988l-0.889,24.288c0.001,2.873,2.369,5.242,5.28,5.242h4.205 c2.911,0,5.279-2.369,5.279-5.28L185.403,277.516z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M165.903,266.007c1.641,0,3.281,0,4.922,0c2.07,0,4.206-0.282,5.06,2.145 c1.031,2.932,1.119,6.526,1.646,9.599c0.172,1.001,1.696,0.577,1.525-0.421c-0.309-1.802-0.618-3.603-0.927-5.405 c-0.281-1.641-0.297-3.725-1.072-5.238c-1.807-3.53-7.965-2.263-11.154-2.263C164.885,264.425,164.884,266.007,165.903,266.007 L165.903,266.007z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M165.903,266.007c1.641,0,3.281,0,4.922,0c2.07,0,4.206-0.282,5.06,2.145 c1.031,2.932,1.119,6.526,1.646,9.599c0.172,1.001,1.696,0.577,1.525-0.421c-0.309-1.802-0.618-3.603-0.927-5.405 c-0.281-1.641-0.297-3.725-1.072-5.238c-1.807-3.53-7.965-2.263-11.154-2.263C164.885,264.425,164.884,266.007,165.903,266.007 L165.903,266.007z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M175.211,281.397l-1.759-1.759c-0.389-0.389-0.389-1.021,0-1.41l1.759-1.759 c0.389-0.389,1.021-0.389,1.41,0l1.759,1.759c0.389,0.389,0.389,1.021,0,1.41l-1.759,1.759 C176.232,281.787,175.601,281.787,175.211,281.397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M183.155,283.524l-2.426-0.552c-0.537-0.122-0.873-0.656-0.751-1.193l0.552-2.426 c0.122-0.537,0.656-0.873,1.193-0.751l2.426,0.552c0.537,0.122,0.873,0.656,0.751,1.193l-0.552,2.426 C184.226,283.31,183.692,283.646,183.155,283.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M177.259,287.674l-2.467,0.323c-0.546,0.071-1.047-0.313-1.118-0.859l-0.322-2.466 c-0.071-0.546,0.313-1.047,0.859-1.118l2.467-0.323c0.546-0.071,1.047,0.313,1.118,0.859l0.322,2.467 C178.19,287.102,177.805,287.603,177.259,287.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M181.597,290.702l-2.154-1.244c-0.477-0.275-0.64-0.885-0.365-1.362l1.244-2.154 c0.275-0.477,0.885-0.64,1.362-0.365l2.154,1.244c0.477,0.275,0.64,0.885,0.365,1.362l-1.244,2.154 C182.684,290.814,182.074,290.977,181.597,290.702z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M175.211,281.397l-1.759-1.759c-0.389-0.389-0.389-1.021,0-1.41l1.759-1.759 c0.389-0.389,1.021-0.389,1.41,0l1.759,1.759c0.389,0.389,0.389,1.021,0,1.41l-1.759,1.759 C176.232,281.787,175.601,281.787,175.211,281.397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M183.155,283.524l-2.426-0.552c-0.537-0.122-0.873-0.656-0.751-1.193l0.552-2.426 c0.122-0.537,0.656-0.873,1.193-0.751l2.426,0.552c0.537,0.122,0.873,0.656,0.751,1.193l-0.552,2.426 C184.226,283.31,183.692,283.646,183.155,283.524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M177.259,287.674l-2.467,0.323c-0.546,0.071-1.047-0.313-1.118-0.859l-0.322-2.466 c-0.071-0.546,0.313-1.047,0.859-1.118l2.467-0.323c0.546-0.071,1.047,0.313,1.118,0.859l0.322,2.467 C178.19,287.102,177.805,287.603,177.259,287.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M181.597,290.702l-2.154-1.244c-0.477-0.275-0.64-0.885-0.365-1.362l1.244-2.154 c0.275-0.477,0.885-0.64,1.362-0.365l2.154,1.244c0.477,0.275,0.64,0.885,0.365,1.362l-1.244,2.154 C182.684,290.814,182.074,290.977,181.597,290.702z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M125.559,308.1c2.854,2.698,6.602,4.49,10.82,4.842l38.633,3.219 c6.794,0.566,13.018-2.732,16.509-8.061H125.559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M125.559,308.1c2.854,2.698,6.602,4.49,10.82,4.842l38.633,3.219 c6.794,0.566,13.018-2.732,16.509-8.061H125.559z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 149.298,
    cy: 259.238,
    r: 5.829
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M143.99,254.653c0.224-0.259,0.465-0.501,0.724-0.724c-1.229-1.229-2.458-2.458-3.686-3.686 c-0.467-0.467-1.191,0.257-0.724,0.724C141.532,252.196,142.761,253.425,143.99,254.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M142.278,259.238c0-0.173,0.014-0.342,0.026-0.512c-1.738,0-3.477,0-5.215,0 c-0.659,0-0.66,1.024,0,1.024c1.738,0,3.476,0,5.215,0C142.292,259.58,142.278,259.411,142.278,259.238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M154.606,254.653c1.229-1.229,2.458-2.458,3.686-3.686c0.467-0.466-0.257-1.191-0.724-0.724 c-1.229,1.229-2.458,2.458-3.686,3.686C154.141,254.153,154.383,254.395,154.606,254.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M149.298,252.218c0.173,0,0.342,0.014,0.512,0.026c0-1.738,0-3.477,0-5.215 c0-0.659-1.024-0.66-1.024,0c0,1.738,0,3.477,0,5.215C148.956,252.232,149.125,252.218,149.298,252.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M161.506,258.726c-1.738,0-3.476,0-5.215,0c0.012,0.17,0.026,0.339,0.026,0.512 s-0.014,0.342-0.026,0.512c1.738,0,3.477,0,5.215,0C162.165,259.75,162.166,258.726,161.506,258.726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M154.606,263.822c-0.224,0.259-0.465,0.5-0.724,0.724c1.229,1.229,2.458,2.458,3.686,3.686 c0.466,0.467,1.191-0.257,0.724-0.724C157.064,266.28,155.835,265.051,154.606,263.822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M143.99,263.822c-1.229,1.229-2.458,2.458-3.686,3.686c-0.467,0.467,0.257,1.191,0.724,0.724 c1.229-1.229,2.458-2.458,3.686-3.686C144.455,264.323,144.213,264.081,143.99,263.822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M149.298,266.257c-0.173,0-0.342-0.014-0.512-0.026c0,1.738,0,3.476,0,5.215 c0,0.659,1.024,0.66,1.024,0c0-1.738,0-3.476,0-5.215C149.64,266.244,149.471,266.257,149.298,266.257z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M147.249,286.061c-0.011-0.058-0.023-0.115-0.023-0.174c0-0.905,1.326-1.692,3.278-2.094 c-0.048-0.092-0.074-0.188-0.074-0.286c0-0.815,1.733-1.475,3.871-1.475c2.138,0,3.871,0.66,3.871,1.475 c0,0.236-0.149,0.457-0.406,0.655c1,0.361,1.683,0.847,1.883,1.392c2.655,0.274,4.61,1.196,4.61,2.295 c0,1.314-2.796,2.38-6.246,2.38c-0.232,0-0.46-0.006-0.685-0.015c-1.254,1.087-4.101,1.848-7.417,1.848 c-4.475,0-8.102-1.382-8.102-3.087C141.809,287.625,144.084,286.481,147.249,286.061z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M147.249,286.061c-0.011-0.058-0.023-0.115-0.023-0.174 c0-0.905,1.326-1.692,3.278-2.094c-0.048-0.092-0.074-0.188-0.074-0.286c0-0.815,1.733-1.475,3.871-1.475 c2.138,0,3.871,0.66,3.871,1.475c0,0.236-0.149,0.457-0.406,0.655c1,0.361,1.683,0.847,1.883,1.392 c2.655,0.274,4.61,1.196,4.61,2.295c0,1.314-2.796,2.38-6.246,2.38c-0.232,0-0.46-0.006-0.685-0.015 c-1.254,1.087-4.101,1.848-7.417,1.848c-4.475,0-8.102-1.382-8.102-3.087C141.809,287.625,144.084,286.481,147.249,286.061z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M147.034,279.993c0.016-0.081,0.033-0.162,0.033-0.245c0-1.273-1.866-2.38-4.612-2.947 c0.067-0.13,0.104-0.264,0.104-0.402c0-1.146-2.438-2.075-5.447-2.075c-3.008,0-5.446,0.929-5.446,2.075 c0,0.331,0.209,0.643,0.571,0.921c-1.406,0.508-2.367,1.191-2.65,1.959c-3.735,0.386-6.486,1.683-6.486,3.228 c0,1.849,3.934,3.348,8.787,3.348c0.326,0,0.647-0.008,0.963-0.021c1.764,1.53,5.769,2.599,10.436,2.599 c6.296,0,11.399-1.945,11.399-4.343C154.687,282.194,151.486,280.584,147.034,279.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M147.034,279.993c0.016-0.081,0.033-0.162,0.033-0.245 c0-1.273-1.866-2.38-4.612-2.947c0.067-0.13,0.104-0.264,0.104-0.402c0-1.146-2.438-2.075-5.447-2.075 c-3.008,0-5.446,0.929-5.446,2.075c0,0.331,0.209,0.643,0.571,0.921c-1.406,0.508-2.367,1.191-2.65,1.959 c-3.735,0.386-6.486,1.683-6.486,3.228c0,1.849,3.934,3.348,8.787,3.348c0.326,0,0.647-0.008,0.963-0.021 c1.764,1.53,5.769,2.599,10.436,2.599c6.296,0,11.399-1.945,11.399-4.343C154.687,282.194,151.486,280.584,147.034,279.993z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAB27B"
    },
    points: "297.657,391.412 298.682,398.969 291.509,400.818 289.777,392.648  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M287.492,402.335c-1.043,0.206-2.159,0.228-2.593-0.152c-0.23-0.227-0.293-0.574-0.155-0.867 c0.095-0.258,0.286-0.469,0.534-0.589c1.325-0.662,4.582,0.431,4.726,0.48c0.081,0.027,0.136,0.103,0.137,0.188 c0,0.085-0.051,0.161-0.129,0.195C289.195,401.91,288.352,402.16,287.492,402.335z M285.835,400.966 c-0.129,0.023-0.254,0.065-0.37,0.124c-0.16,0.061-0.283,0.192-0.335,0.355c-0.099,0.277-0.023,0.386,0.047,0.442 c0.497,0.469,2.616,0.064,4.139-0.438C288.196,401.07,287.015,400.906,285.835,400.966z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M289.98,401.592c-0.026,0.013-0.056,0.017-0.084,0.009c-1.091-0.247-3.467-1.668-3.475-2.646 c-0.025-0.232,0.092-0.542,0.628-0.706c0.391-0.121,0.815-0.078,1.174,0.121c1.242,0.667,1.913,2.886,1.945,2.989 c0.019,0.071-0.001,0.146-0.054,0.197C290.076,401.585,290.027,401.598,289.98,401.592z M287.256,398.6l-0.116,0.012 c-0.351,0.101-0.346,0.25-0.351,0.303c0.061,0.579,1.664,1.741,2.826,2.151c-0.288-0.932-0.854-1.753-1.623-2.352 C287.769,398.588,287.508,398.547,287.256,398.6L287.256,398.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M290.636,400.245l9.159-1.81c0.345-0.069,0.692,0.112,0.834,0.434l3.128,7.124 c0.282,0.63,0,1.369-0.63,1.651c-0.081,0.036-0.165,0.064-0.252,0.082c-3.313,0.595-6.285,0.995-10.394,1.813 c-4.85,0.96-3.505,1.297-9.192,2.506c-3.427,0.725-4.828-3.057-3.409-3.537c6.503-2.158,6.797-4.308,8.897-7.203 C289.246,400.735,289.908,400.358,290.636,400.245z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "290.711,397.056 298.258,395.841 297.735,391.987 290.035,393.864  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAB27B"
    },
    points: "217.733,390.974 215.528,398.275 208.234,396.979 210.051,388.828  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M203.95,396.69c-1.035-0.246-2.059-0.689-2.296-1.215c-0.116-0.302-0.028-0.644,0.219-0.854 c0.193-0.196,0.455-0.308,0.73-0.314c1.48-0.052,3.99,2.295,4.1,2.399c0.062,0.059,0.081,0.15,0.047,0.228 c-0.035,0.077-0.113,0.126-0.198,0.124C205.676,397.012,204.805,396.889,203.95,396.69z M203.011,394.757 c-0.127-0.032-0.258-0.046-0.389-0.041c-0.171-0.011-0.337,0.057-0.452,0.184c-0.205,0.211-0.181,0.342-0.141,0.422 c0.257,0.633,2.353,1.145,3.947,1.32C205.116,395.832,204.11,395.193,203.011,394.757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M206.522,397.048c-0.029,0.001-0.058-0.008-0.081-0.027c-0.89-0.677-2.462-2.956-2.062-3.85 c0.074-0.221,0.309-0.455,0.865-0.381c0.406,0.052,0.774,0.268,1.018,0.597c0.853,1.123,0.542,3.42,0.529,3.527 c-0.012,0.072-0.062,0.133-0.131,0.157C206.612,397.081,206.563,397.073,206.522,397.048z M205.287,393.195l-0.11-0.037 c-0.362-0.054-0.419,0.083-0.445,0.13c-0.185,0.552,0.791,2.275,1.678,3.13c0.125-0.967-0.049-1.949-0.5-2.814 C205.758,393.397,205.537,393.252,205.287,393.195L205.287,393.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M207.678,396.095l9.084,2.156c0.342,0.081,0.583,0.389,0.579,0.741l-0.112,7.78 c-0.005,0.69-0.568,1.246-1.259,1.241c-0.088-0.001-0.177-0.011-0.263-0.03c-3.261-0.834-6.13-1.704-10.208-2.667 c-4.811-1.14-3.727-0.275-9.403-1.537c-3.419-0.764-3.123-4.786-1.633-4.633c6.811,0.737,7.972-1.097,11.085-2.859 C206.211,395.964,206.969,395.896,207.678,396.095z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "216.714,394.348 217.677,391.159 211.365,389.195 210.051,388.828 209.321,392.104  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "281.824,237.071 246.447,228.934 240.388,252.014 221.026,306.882 207.902,389.301  221.026,392.714 239.925,311.869 262.762,259.67 281.824,261.554  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3
    },
    points: "259.834,266.361 258.001,254.903 256.241,274.574  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "207.902,387.09 221.852,390.667 221.202,393.552 207.283,389.561  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "286.47,309.132 280.935,250.975 277.65,241.524 269.039,241.862 256.776,247.24  267.16,312.155 285.516,394.328 299.946,391.114  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "284.878,393.919 300.293,390.537 300.683,392.714 285.268,396.115  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M281.854,222.01c0.874-9.951,3.783-38.671,3.783-38.671s-2.974-1.738-8.335-3.273 c-3.451,1.682-11.155,5.282-13.719,5.195c-2.292-0.077-3.728-4.624-4.404-7.476c-3.367,0.061-6.997,0.374-10.874,1.053 l-3.167,10.167c0,0-6.333,25.667-3.167,52.5c0,0,9.038,6.5,27.079,6.5c7.126,0,13.421-2,13.421-2S281.306,228.245,281.854,222.01z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD8C6A"
    },
    d: "M274.396,179.318c-2.432-2.833-0.092-13.895-0.092-13.895l-8.643,3.167 c0,0-0.905,7.665-3.072,9.221c-0.85,0.611-2.124-0.045-3.23-0.028l2.285,7.29l5.691,0.559l10.434-5.427 C276.735,179.898,275.21,180.267,274.396,179.318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M264.605,173.884c5.977-0.779,8.455-4.547,9.45-7.145c0.143-0.813,0.249-1.316,0.249-1.316 l-8.643,3.167C265.66,168.59,265.332,171.343,264.605,173.884z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "260.4,177.249 264.111,185.441 257.786,189.122 257.623,177.307  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "260.4,177.249 264.111,185.441 257.786,189.122 257.623,177.307  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "276.914,179.221 263.038,185.087 267.804,191.346 279.39,180.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "276.914,179.221 263.038,185.087 267.804,191.346 279.39,180.34  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD8C6A"
    },
    d: "M235.137,187.006l-16.5,8.5c0,0-7-7.807-12.667-17.737c0,0,1-5.93-0.833-7.596 c-1.833-1.667-4.667-7.047-4.667-7.047l-4.167,1.297l-2.5,3.583l3,5.5l4.5,5.715c0,0,6.333,26.118,15.833,26.118 s23.833-9.667,23.833-9.667L235.137,187.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M251.945,178.298c0,0-5.308-1.125-20.141,8.208l6.833,12.667l9.167-4.5l7-10.988L251.945,178.298z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "228.97,187.006 231.804,185.631 239.47,199.173 236.97,200.694  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "228.97,187.006 231.804,185.631 239.47,199.173 236.97,200.694  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M245.137,189.006l0.155-0.499c-2.294,2.461-3.811,7.89-4.213,9.466l2.521-1.237 C244.426,191.897,245.137,189.006,245.137,189.006z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD8C6A"
    },
    d: "M294.939,192.846l7.865,7.274c0,0,7.333-9.922,12.833-16.435c0,0-1.167-4.512,1.333-7.179 l1.333-4.125l3.833-1.042l5,6.916l-6.667,8.251c0,0-12,24-16,24.5s-15.093-10.313-15.093-10.313L294.939,192.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M280.089,181.402c0,0,5.423-0.175,18.385,11.619l-8.953,11.269l-8.233-6.041l-4.96-12.047 L280.089,181.402z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "301.176,194.011 298.628,192.16 288.701,204.143 290.895,206.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "301.176,194.011 298.628,192.16 288.701,204.143 290.895,206.08  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M284.672,192.941c-0.223,2.227-0.47,4.702-0.723,7.26l2.927,2.148 C286.747,198.992,285.49,195.131,284.672,192.941z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M264.721,141.126c0,0-8.842-0.114-3.012,8.501l6.774-7.191L264.721,141.126z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M289.279,147.089c0.181,0.445,0.26,0.953,0.236,1.431c-0.068,1.361-1.116,2.089-2.347,2.412 c-0.28,0.074-0.161,0.508,0.12,0.434c1.26-0.331,2.388-1.059,2.631-2.42c0.115-0.642,0.042-1.37-0.205-1.977 C289.605,146.705,289.17,146.82,289.279,147.089L289.279,147.089z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD8C6A"
    },
    d: "M281.045,155.556c-3.045,7.399-4.18,10.583-9.319,13.149c-7.735,3.868-16.151-1.501-15.379-9.651 c0.708-7.341,5.589-18.241,14.004-18.667c6.013-0.367,11.184,4.21,11.551,10.223 C282.004,152.302,281.711,153.996,281.045,155.556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M268.332,153.411c-0.217,0.612-0.714,1.001-1.112,0.869c-0.398-0.131-0.558-0.754-0.353-1.368 c0.205-0.614,0.714-1.001,1.112-0.87C268.377,152.174,268.5,152.816,268.332,153.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M261.383,151.047c-0.218,0.624-0.714,1.001-1.112,0.869c-0.398-0.131-0.558-0.754-0.353-1.368 c0.205-0.614,0.714-1.001,1.11-0.858C261.425,149.834,261.588,150.433,261.383,151.047z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C13B37"
    },
    d: "M263.144,152.895c-1.032,1.215-2.225,2.283-3.546,3.174c0.486,0.667,1.236,1.091,2.058,1.162 L263.144,152.895z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M271.603,152.971c-0.165-0.025-0.294-0.157-0.315-0.322c-0.332-1.212-1.155-2.23-2.271-2.809 c-0.19-0.096-0.268-0.327-0.173-0.518c0.093-0.186,0.318-0.261,0.504-0.168c0.004,0.002,0.008,0.004,0.012,0.007 c1.346,0.686,2.326,1.924,2.684,3.391c0.027,0.206-0.117,0.395-0.323,0.422h0C271.682,152.984,271.642,152.983,271.603,152.971z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M260.395,147.13c-0.137-0.025-0.251-0.12-0.301-0.25c-0.071-0.198,0.029-0.417,0.226-0.493 c1.153-0.476,2.468-0.346,3.506,0.346c0.166,0.113,0.208,0.34,0.095,0.506c-0.006,0.008-0.012,0.016-0.018,0.024 c-0.123,0.167-0.358,0.203-0.525,0.081c-0.002-0.001-0.003-0.002-0.005-0.004l0,0c-0.828-0.511-1.85-0.596-2.751-0.23 C260.55,147.14,260.471,147.147,260.395,147.13z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M262.037,160.531c0,0,2.957,0.75,5.135,0c0,0-0.161,3.342-4.353,2.656 c-0.197-0.032-0.781-0.164-0.781-0.164S262.381,162.062,262.037,160.531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M262.725,160.67v0.767c0,0,1.925,0.742,4.19,0.079c0.233-0.535,0.257-0.985,0.257-0.985 C265.64,161.058,263.728,160.844,262.725,160.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C13B37"
    },
    d: "M266.434,162.271c-0.333-0.055-0.697-0.085-1.081-0.085c-1.425,0-2.588,0.418-2.762,0.957 c0.091,0.019,0.174,0.035,0.227,0.044C264.767,163.506,265.839,162.953,266.434,162.271z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M277.779,150.337c0,0-0.989,1.11,0.571,2.288c0,0-4.463,4.174-2.729,8.694 c1.734,4.52,6.005,0.1,7.254-1.245c1.249-1.345,7.475-9.154,2.424-14.047c-5.051-4.893-17.125-8.201-17.605-14.157 c0,0-1.99,3.972,0.27,5.275c0,0-5.321,2.437-6.091-1.449c0,0-2.754,4.177,0.98,4.566c0,0-2.121,2.958,1.686,3.02 C268.345,143.346,275.194,145.675,277.779,150.337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD8C6A"
    },
    d: "M281.112,162.07c-0.938,1.19-2.307,1.962-3.811,2.148c-2.002,0.217-2.684-1.653-1.857-3.385 c0.757-1.551,2.703-3.537,4.588-2.988c1.356,0.443,2.096,1.901,1.654,3.257C281.568,161.463,281.372,161.793,281.112,162.07z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanner);
export default __webpack_public_path__ + "static/media/planner.73653edf6c25c83b9277aa15f82f273d.svg";
export { ForwardRef as ReactComponent };